import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loadingSubject.asObservable();

  private canShowLoader = true;
  private loadingCount = 0;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.reset();
      }
    });
  }

  showLoading(throttleTime: number = 0) {
    if (this.canShowLoader && this.loadingCount === 0) {
      this.loadingSubject.next(true);
      this.throttleShowLoading(throttleTime);
    }

    this.loadingCount++;
  }

  hideLoading() {
    this.loadingCount--;

    if (this.loadingCount <= 0) {
      this.loadingCount = 0;
      this.loadingSubject.next(false);
    }
  }

  private throttleShowLoading(throttleTime: number) {
    this.canShowLoader = false;
    timer(throttleTime).subscribe(() => {
      this.canShowLoader = true;
    });
  }

  private reset() {
    this.loadingCount = 0;
    this.loadingSubject.next(false);
    this.canShowLoader = true;
  }
}
